<template>
    <div v-if="!isLoading" class="wrapper disabled-copy" @click.right.prevent @copy.prevent @paste.prevent>
        <div>
            <div class="columns is-tablet">
                <div class="column is-12-mobile is-9-tablet">
                    <back-button class="mb-5"/>
                    <div class="is-flex is-align-items-center">
                        <h1 class="is-size-5 is-size-4-desktop has-text-weight-bold mr-5">{{ d.focus.FundBasicsName }} - <span class="color-grey">Comparison To Peers</span></h1>
                        <div class="is-hidden-mobile"><PageHelpDropdown  :height="'560px'" :pageHelp="'compare'"/></div>
                    </div>
                    <div class="m-b-20 m-t-20-mobile">
                        <h3 class="has-text-weight-400">Compare a fund to category peers. See top funds for 5 different criteria</h3>
                    </div>

                    <div class="is-flex is-align-items-start is-hidden-tablet">
                        <div class="column is-12-mobile is-4-full-hd p-0" style="float: left;">
                            <p class="is-size-7 is-size-6-tablet">Comparing:</p>
                            <h2 class="has-text-weight-bold is-size-6 is-size-5-tablet">{{ d.focus.FundBasicsName }}</h2>
                        </div>
                    </div>

                    <div style="position: sticky; top: 59px; background: rgb(245, 244, 244); z-index: 50; width: calc(100% + 36px); margin: 0px -18px; display: flex; flex-flow: wrap;" class="columns border-bottom border-top banner-to-content">
                        <div class="column is-12-mobile is-4-full-hd p-b-0-mobile is-hidden-mobile" style="float: left;">
                            <p class="is-size-7 is-size-6-tablet">Comparing:</p>
                            <h2 class="has-text-weight-bold is-size-6 is-size-5-tablet">{{ d.focus.FundBasicsName }}</h2>
                        </div>
                        <div class="column is-6-mobile is-3-full-hd p-b-0-mobile" style="float: left;">
                            <p class="is-size-7 is-size-6-tablet">Peer Category:</p>
                            <h2 class="has-text-weight-bold is-size-7 is-size-6-tablet mb-2">
                                <a class="has-text-underline" v-if="d.focus.morningstarcategories" @click="searchCategory(d.focus.CategoryId, d.focus.morningstarcategories)" v-tooltip="'Click to view all funds in this category'">{{ d.focus.morningstarcategories }}</a>
                                <span v-else class="not-available">n/a</span>
                            </h2>
                        </div>

                        <div class="column is-2-mobile is-3-full-hd p-b-0-mobile" style="float: left; clear: left;">
                            <p class="is-size-7 is-size-6-tablet">Peers:</p>
                            <h2 class="has-text-weight-bold is-size-7 is-size-6-tablet">
                                {{ d.total }}
                            </h2>
                        </div>
                        <div class="column is-4-mobile is-2-full-hd see-returns m-l-15-tablet p-l-5-mobile" style="float: left;">
                            <currency-toggle v-on:currency-change="currencyChange"/>
                        </div>
                    </div>
                    <div class="columns m-t-10 m-t-0-mobile">
                        <div class="column is-12-tablet is-11-desktop is-8-fullhd">
                            <h2 class="is-size-6 is-size-5-desktop has-text-weight-bold m-b-20-tablet">Fund Ranking</h2>
                            <div class="is-flex is-justify-content-center is-align-items-center is-hidden-tablet">
                                <p class="has-text-center mb-2 is-size-7-mobile grey-text-2"><img src="/img/h-scroll.svg" class="h-scroll-icon"> Swipe table to see more</p>
                            </div>
                            <div class="scroll-table-wrapper">

                                <table class="comparison-table-1">
                                    <thead>
                                        <tr>
                                            <td>Criteria</td>
                                            <td>Rank</td>
                                            <td>Out of<button v-tooltip="{content: 'Number of funds with data for this criteria', trigger: 'hover click'}">?</button></td>
                                            <td>This Fund</td>
                                            <td>Best Fund</td>
                                            <td>Worst Fund</td>
                                            <td>Median Fund</td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td>NTR 1Y <button v-tooltip="{content: 'Annualised Net Total Return 1 Year', trigger: 'hover click'}">?</button></td>
                                        <td>
                                            <span v-if="d.CumulativeTotalReturn1Year.rank" class="has-text-weight-bold">{{d.CumulativeTotalReturn1Year.rank}}</span>
                                            <span v-else class="not-available">n/a</span>
                                        </td>
                                        <td><span class="has-text-weight-bold">{{d.CumulativeTotalReturn1Year.total}}</span></td>
                                        <td><pos-neg :suffix="'%'" :val="d.focus.CumulativeTotalReturn1Year"/></td>
                                        <td><pos-neg :suffix="'%'" :val="d.maxminavg.CumulativeTotalReturn1Year.max"/></td>
                                        <td><pos-neg :suffix="'%'" :val="d.maxminavg.CumulativeTotalReturn1Year.min"/></td>
                                        <td><pos-neg :suffix="'%'" :val="d.median.CumulativeTotalReturn1Year"/></td>
                                    </tr>
                                    <tr>
                                        <td>NTR 3Y <button v-tooltip="{content: 'Annualised Net Total Return 3 Year', trigger: 'hover click'}">?</button></td>
                                        <td>
                                            <span v-if="d.TotalReturn3Years.rank" class="has-text-weight-bold">{{d.TotalReturn3Years.rank}}</span>
                                            <span v-else class="not-available">n/a</span>
                                        </td>
                                        <td><span class="has-text-weight-bold">{{d.TotalReturn3Years.total}}</span></td>
                                        <td><pos-neg :suffix="'%'" :val="d.focus.TotalReturn3Years"/></td>
                                        <td><pos-neg :suffix="'%'" :val="d.maxminavg.TotalReturn3Years.max"/></td>
                                        <td><pos-neg :suffix="'%'" :val="d.maxminavg.TotalReturn3Years.min"/></td>
                                        <td><pos-neg :suffix="'%'" :val="d.median.TotalReturn3Years"/></td>
                                    </tr>
                                    <tr>
                                        <td>NTR 5Y <button v-tooltip="{content: 'Annualised Net Total Return 5 Year', trigger: 'hover click'}">?</button></td>
                                        <td>
                                            <span v-if="d.TotalReturn5Years.rank" class="has-text-weight-bold">{{d.TotalReturn5Years.rank}}</span>
                                            <span v-else class="not-available">n/a</span>
                                        </td>
                                        <td><span class="has-text-weight-bold">{{d.TotalReturn5Years.total}}</span></td>
                                        <td><pos-neg :suffix="'%'" :val="d.focus.TotalReturn5Years"/></td>
                                        <td><pos-neg :suffix="'%'" :val="d.maxminavg.TotalReturn5Years.max"/></td>
                                        <td><pos-neg :suffix="'%'" :val="d.maxminavg.TotalReturn5Years.min"/></td>
                                        <td><pos-neg :suffix="'%'" :val="d.median.TotalReturn5Years"/></td>
                                    </tr>
                                    <tr>
                                        <td class="is-has-text-nowrap">OGC<button v-tooltip="{content: 'Ongoing Charge (includes Mgt Fee)', trigger: 'hover click'}">?</button></td>
                                        <td>
                                            <span v-if="d.ongoingchargecomp.rank" class="has-text-weight-bold">{{d.ongoingchargecomp.rank}}</span>
                                            <span v-else class="not-available">n/a</span>
                                        </td>
                                        <td><span class="has-text-weight-bold">{{d.ongoingchargecomp.total}}</span></td>
                                        <td><pos-neg :suffix="'%'" :val="d.focus.ongoingchargecomp"/></td>
                                        <td><pos-neg :suffix="'%'" :val="d.maxminavg.ongoingchargecomp.min"/></td>
                                        <td><pos-neg :suffix="'%'" :val="d.maxminavg.ongoingchargecomp.max"/></td>
                                        <td><pos-neg :suffix="'%'" :val="d.median.ongoingchargecomp"/></td>
                                    </tr>
                                    <tr>
                                        <td class="is-white-space-nowrap">3Y SD<button v-tooltip="{content: '3 Year Standard Deviation', trigger: 'hover click'}">?</button></td>
                                        <td>
                                            <span v-if="d.standarddev36m.rank" class="has-text-weight-bold">{{d.standarddev36m.rank}}</span>
                                            <span v-else class="not-available">n/a</span>
                                        </td>
                                        <td><span class="has-text-weight-bold">{{d.maxminavg.standarddev36m.c}}</span></td>
                                        <td><pos-neg :suffix="'%'" :val="d.focus.standarddev36m"/></td>
                                        <td><pos-neg :suffix="'%'" :val="d.maxminavg.standarddev36m.min "/></td>
                                        <td><pos-neg :suffix="'%'" :val="d.maxminavg.standarddev36m.max "/></td>
                                        <td><pos-neg :suffix="'%'" :val="d.median.standarddev36m"/></td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                       </div>
                    </div>
                    <div class="columns is-align-items-flex-end is-flex m-t-40-tablet">
                        <div class="column is-6-mobile is-3-tablet mt-1 m-t-0-tablet">
                            <h2 class="is-size-6 is-size-5-desktop has-text-weight-bold is-white-space-nowrap">Compare by</h2>
                            <div class="select-wrapper compare">
                                <b-select class="mt-1" @input="api" v-model="selector" placeholder="Select a name">
                                    <option v-for="d in dict" :key="d.id" :value="d.id">
                                        {{ d.name }}
                                    </option>
                                </b-select>
                            </div>
                        </div>
                        
                        <div class="column is-6-mobile is-4-tablet p-t-0-mobile p-t-20-tablet">
                            <p class="mb-0 is-size-7 has-text-right"><span class="grey-text">Data available for:</span>
                                {{  d[selector].total}} Funds </p>
                            <p class="mb-0 is-size-7 has-text-right"><span class="grey-text">% of Peer Group:</span>
                                {{ ((d[selector].total/d2.total  ) * 100).toFixed(0) }}%
                            </p>
                        </div>
                    </div>
                    <h2 class="is-size-6 is-size-5-desktop has-text-weight-bold m-b-40-tablet m-b-10-mobile">
                        Fund Distribution for <a class="has-text-underline" v-if="d.focus.morningstarcategories" @click="searchCategory(d.focus.CategoryId, d.focus.morningstarcategories)" v-tooltip="'Click to view all funds in this category'">{{ d.focus.morningstarcategories }}</a>
                    </h2>
                    <div class="columns">
                        <div class="column is-5 is-4-tablet is-4-desktop">
                            <table class="comparison-table-2">
                                <thead>
                                    <tr>
                                        <td></td>
                                        <td>{{ dict[selector].name }}</td>
                                        <td>Rank</td>
                                    </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td>This Fund</td>
                                    <td><pos-neg :suffix="'%'" :val="d2.focus[selector]"/></td>
                                    <td><span>{{ d2.focus.rank_number }}</span></td>
                                </tr>
                                <tr>
                                    <td class="is-white-space-nowrap">
                                        <a @click="searchISIN(d2.bestActive.ISIN)">Best Active</a>
                                        <button v-tooltip="{content: 'Best Active fund with data for this criteria', trigger: 'hover click'}">?</button></td>
                                    <td>
                                        <pos-neg  :suffix="'%'" v-if="d2.hasOwnProperty('bestActive')" :val="d2.bestActive[selector]"/>
                                    </td>
                                    <td><span v-if="d2.hasOwnProperty('bestActive')">{{
                                            d2.bestActive.rank_number
                                        }}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <a @click="searchISIN(d2.bestPassive.ISIN)">Best Passive</a>
                                        <button v-tooltip="{content: 'Best Passive fund with data for this criteria', trigger: 'hover click'}">?</button></td>
                                    <td>
                                        <pos-neg :suffix="'%'" v-if="d2.hasOwnProperty('bestPassive')" :val="d2.bestPassive[selector]"/>
                                    </td>
                                    <td><span
                                        v-if="d2.hasOwnProperty('bestPassive')">{{ d2.bestPassive.rank_number }}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <a @click="searchISIN(d2.bestEsg.ISIN)">Best ESG</a>
                                        <button v-tooltip="{content: 'Best ESG fund with data for this criteria', trigger: 'hover click'}">?</button></td>
                                    <td>
                                        <pos-neg :suffix="'%'" v-if="d2.hasOwnProperty('bestEsg')" :val="d2.bestEsg[selector]"/>
                                    </td>
                                    <td>

                                        <span v-if="d2.hasOwnProperty('bestEsg')">{{ d2.bestEsg.rank_number }}</span>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="column is-8">
                            <div class="is-relative">
                            <div class="graph-wrapper">
                                <bar-chart :name="''" :selector="selector" :catid="d.focus.CategoryId" :currentFund="d2.focus"></bar-chart>
                            </div>
                            </div>
                            <div style="font-size: 13px" class="has-text-centered p-t-80 p-t-0-mobile">
                                {{ dict[selector].name }}
                            </div>
                        </div>
                    </div>

                    <h2 class="is-size-6 is-size-5-desktop has-text-weight-bold">Top funds in this Category</h2>
                    <div class="columns">
                        <div class="column">
                            <div class=" m-l-5 is-flex is-justify-content-flex-start is-flex-wrap-nowrap is-align-items-center mt-4">
                                <p class="is-inline-flex is-size-7 is-size-6-tablet is-has-text-nowrap">Show Top</p>
                                <div class="select-items is-inline-flex">
                                    <a v-if="counter>5" @click="counter=counter-5">-</a>
                                    <span  v-tooltip="'Select number of top funds to see'">{{ counter }}</span>
                                    <a v-if="counter<15" @click="counter=counter+5">+</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="table-information-compare" class="columns is-mobile">
                        <div class="column is-12">
                            <div class="is-flex is-justify-content-center is-align-items-center is-hidden-tablet">
                                <p class="has-text-center is-size-7-mobile  grey-text-2"><img src="/img/h-scroll.svg" class="h-scroll-icon"> Swipe table to see more</p>
                            </div>
                            <ul class="comparison-tabs is-uppercase">
                                <li :class="{'active':type==1}"><a @click="type=1">overview<span></span></a></li>
                                <li :class="{'active':type==2}"><a @click="type=2">performance<span></span></a></li>
                                <li :class="{'active':type==3}"><a @click="type=3">income & charges<span></span></a>
                                </li>
                                <li :class="{'active':type==4}"><a @click="type=4">attributes<span></span></a></li>
                            </ul>
                            <div class="scroll-table-wrapper">

                                <table v-if="type==1" id="comparison-table-3" class="comparison-table-3">
                                    <thead>
                                        <tr>
                                            <td>Rank</td>
                                            <td>Top {{ dict[selector].name }}</td>
                                            <td class="is-white-space-nowrap">CCY<button v-tooltip="{content: 'Currency of Share Class', trigger: 'hover click'}">?</button></td>
                                            <td class="is-white-space-nowrap" v-if="selector!='ongoingchargecomp'">OGC<button v-tooltip="{content: 'Ongoing Charge (includes Mgt Fee)', trigger: 'hover click'}">?</button></td>
                                            <td v-if="selector!='CumulativeTotalReturn1Year'">NTR 1Y</td>
                                            <td v-if="selector!='TotalReturn3Years'">NTR 3Y</td>
                                            <td v-if="selector!='TotalReturn5Years'">NTR 5Y</td>
                                            <td v-if="selector!='fundnetassetgbp'">
                                                <!--
                                                <span v-if="$store.state.search.currency">NATIVE</span>
                                                <span v-else>GBP</span>
                                                -->

                                                Net Assets
                                                <button v-tooltip="{
                                                            content: 'Fund Net assets', trigger: 'hover click'
                                                        }">?
                                                </button></td>
                                            <td class="is-white-space-nowrap" v-if="selector!='standarddev36m'" >3Y SD<button v-tooltip="{content: '3 Year Standard Deviation', trigger: 'hover click'}">?</button></td>
                                            <td></td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    <template>
                                        <tr>
                                            <td colspan="9" class="full-column">
                                                <span class="has-text-weight-bold ">
                                                    <router-link class="has-text-underline" :to="{name:'Detailedview Comparison',params:{id:d2.focus.ISIN}}">
                                                        {{ getShort(d2.focus.FundBasicsName) }} 
                                                    </router-link>
                                                    <button v-tooltip="{content: 'Click to see fund details', trigger: 'hover click'}">?</button>
                                                </span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td><span class="has-text-weight-bold">{{ d2.focus.rank_number }}</span></td>
                                            <td>
                                            <span class="has-text-weight-bold">
                                            <pos-neg :val="d2.focus[selector]" :suffix="'%'"/>
                                            </span>
                                            </td>
                                            <td><span>{{ d2.focus.CurrencyId }}</span></td>
                                            <td v-if="selector!='ongoingchargecomp'"> <pos-neg :val="d2.focus.ongoingchargecomp" :suffix="'%'"/></td>
                                            <td v-if="selector!='CumulativeTotalReturn1Year'"><pos-neg :val="d2.focus.CumulativeTotalReturn1Year" :suffix="'%'"/></td>
                                            <td v-if="selector!='TotalReturn3Years'"><pos-neg :val="d2.focus.TotalReturn3Years" :suffix="'%'"/></td>
                                            <td v-if="selector!='TotalReturn5Years'"><pos-neg :val="d2.focus.TotalReturn5Years" :suffix="'%'"/></td>
                                            <td class="is-lowercase"  v-if="selector!='fundnetassetgbp'">
                                                <net-asset :val="d2.focus.fundnetassetgbp"/>
                                            </td>
                                            <td  v-if="selector!='standarddev36m'"><pos-neg :val="d2.focus.standarddev36m" :suffix="'%'"/></td>
                                            <td>
                                                <Buttons :ISIN="d2.focus.ISIN" :fundId="d2.focus.fund_id" :fund_data="d2.focus"/>

                                            </td>
                                        </tr>
                                    </template>
                                    <template v-for="(i, index) in d2.top15">
                                        <tr :id="`row-detail-${i.ISIN}`" :key="index" v-if="counter > index">
                                            <td colspan="9" class="full-column">
                                                <span class="has-text-weight-bold">
                                                    <router-link class="has-text-underline" :to="{name:'Detailedview Comparison',params:{id:i.ISIN}}">
                                                        {{ getShort(i.FundBasicsName) }} 
                                                    </router-link>
                                                    
                                                    <button v-tooltip="{content: 'Click to see fund details', trigger: 'hover click'}">?</button>
                                                </span>
                                                
                                            </td>
                                        </tr>
                                        <tr :key="index" v-if="counter > index">
                                            <td><span class="has-text-weight-bold">{{ i.rank_number }}</span></td>
                                            <td>
                                            <span class="has-text-weight-bold">
                                                <pos-neg :val="i[selector]" :suffix="'%'"/>
                                            </span>
                                            </td>
                                            <td><span>{{ i.CurrencyId }}</span></td>
                                                <td v-if="selector!='ongoingchargecomp'"><pos-neg :val="i.ongoingchargecomp" :suffix="'%'"/>  </td>
                                            <td v-if="selector!='CumulativeTotalReturn1Year'"><pos-neg :val="i.CumulativeTotalReturn1Year" :suffix="'%'"/></td>
                                            <td v-if="selector!='TotalReturn3Years'"><pos-neg :val="i.TotalReturn3Years" :suffix="'%'"/></td>
                                            <td v-if="selector!='TotalReturn5Years'"><pos-neg :val="i.TotalReturn5Years" :suffix="'%'"/></td>
                                            <td class="is-lowercase" v-if="selector!='fundnetassetgbp'"><net-asset :val="i.fundnetassetgbp"/></td>
                                            <td v-if="selector!='standarddev36m'"><pos-neg :val="i.standarddev36m" :suffix="'%'"/></td>
                                            <td>
                                                <Buttons :ISIN="i.ISIN" :fundId="i.fund_id" :fund_data="i"/>
                                            </td>
                                        </tr>
                                    </template>
                                    </tbody>
                                </table>


                                <table v-if="type==2" id="comparison-table-3" class="comparison-table-3">
                                    <thead>
                                    <tr>
                                        <td>Rank</td>
                                        <td>Top {{ dict[selector].name }}</td>
                                        <td class="is-white-space-nowrap">CCY<button v-tooltip="{content: 'Currency of Share Class', trigger: 'hover click'}">?</button></td>
                                        <td v-if="selector!='CumulativeTotalReturn1Year'" class="pr-0" style="text-align: right!important;">NTR 1Y</td>
                                        <td v-if="selector!='CumulativeTotalReturn1Year'" class="pl-0" style="text-align:left!important;"><span class="sep"></span>Rank</td>
                                        <td v-if="selector!='TotalReturn3Years'" class="pr-0" style="text-align: right!important;">NTR 3Y</td>
                                        <td v-if="selector!='TotalReturn3Years'" class="pl-0" style="text-align:left!important;"><span class="sep"></span>Rank</td>
                                        <td v-if="selector!='TotalReturn5Years'" class="pr-0" style="text-align: right!important;">NTR 5Y </td>
                                        <td v-if="selector!='TotalReturn5Years'" class="pl-0" style="text-align:left!important;"><span class="sep"></span>Rank</td>
                                        <td v-if="selector!='standarddev36m'" class="pr-0" style="text-align: right!important;">3Y SD<button v-tooltip="{content: '3Y Standard Deviation', trigger: 'hover click'}">?</button></td>
                                        <td v-if="selector!='standarddev36m'" class="pl-0" style="text-align:left!important;"><span class="sep"></span>Rank</td>
                                        <td></td>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <template>
                                        <tr>
                                            <td colspan="10" class="full-column">
                                                <span class="has-text-weight-bold">
                                                    <router-link class="has-text-underline" :to="{name:'Detailedview Comparison',params:{id:d2.focus.ISIN}}">
                                                        {{ getShort(d2.focus.FundBasicsName) }} 
                                                    </router-link>
                                                    <button v-tooltip="{content: 'Click to see fund details', trigger: 'hover click'}">?</button>
                                                </span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td><span class="has-text-weight-bold">{{ d2.focus.rank_number }}</span></td>
                                            <td>
                                            <span class="has-text-weight-bold">
                                                <pos-neg :val="d2.focus[selector]" :suffix="'%'"/>
                                            </span>
                                            </td>
                                            <td><span>{{ d2.focus.CurrencyId }}</span></td>
                                            <td v-if="selector!='CumulativeTotalReturn1Year'" class="pr-0" style="text-align: right!important;"><span><pos-neg :val="d2.focus.CumulativeTotalReturn1Year" :suffix="'%'"/></span></td>
                                            <td v-if="selector!='CumulativeTotalReturn1Year'" class="pl-0" style="text-align:left!important;"><span class="sep"></span><span v-html='findRank("CumulativeTotalReturn1Year", d2.focus.ISIN)'></span></td>
                                            <td v-if="selector!='TotalReturn3Years'" class="pr-0" style="text-align: right!important;"><span><pos-neg :val="d2.focus.TotalReturn3Years" :suffix="'%'"/></span></td>
                                            <td v-if="selector!='TotalReturn3Years'" class="pl-0" style="text-align:left!important;"><span class="sep"></span><span v-html='findRank("TotalReturn3Years", d2.focus.ISIN)'></span></td>
                                            <td v-if="selector!='TotalReturn5Years'" class="pr-0" style="text-align: right!important;"><span><pos-neg :val="d2.focus.TotalReturn5Years" :suffix="'%'"/></span></td>
                                            <td v-if="selector!='TotalReturn5Years'" class="pl-0" style="text-align:left!important;"><span class="sep"></span><span v-html='findRank("TotalReturn5Years", d2.focus.ISIN)'></span></td>
                                            <td v-if="selector!='standarddev36m'" class="pr-0" style="text-align: right!important;"><span><pos-neg :val="d2.focus.standarddev36m " :suffix="'%'"/></span></td>
                                            <td v-if="selector!='standarddev36m'" class="pl-0" style="text-align:left!important;"><span class="sep"></span><span v-html='findRank("standarddev36m", d2.focus.ISIN)'></span></td>
                                            <td>
                                                <Buttons :ISIN="d2.focus.ISIN" fund-id="d2.focus.fund_id" :fund_data="d2.focus"></Buttons>
                                            </td>
                                        </tr>
                                    </template>
                                    <template v-for="(i, index) in d2.top15">
                                        <tr :id="`row-detail-${i.ISIN}`" :key="index" v-if="counter > index">
                                            <td colspan="10" class="full-column">
                                                <span class="has-text-weight-bold">
                                                    <router-link class="has-text-underline" :to="{name:'Detailedview Comparison',params:{id:i.ISIN}}">
                                                        {{ getShort(i.FundBasicsName) }} 
                                                    </router-link>
                                                    <button v-tooltip="{content: 'Click to see fund details', trigger: 'hover click'}">?</button>
                                                </span>
                                            </td>
                                        </tr>
                                        <tr :key="index" v-if="counter > index">
                                            <td><span class="has-text-weight-bold">{{ i.rank_number }}</span></td>
                                            <td>
                                            <span class="has-text-weight-bold">
                                                <pos-neg :val="i[selector]" :suffix="'%'"/>
                                            </span>
                                            </td>
                                            <td><span>{{ i.CurrencyId }}</span></td>
                                            <td v-if="selector!='CumulativeTotalReturn1Year'" class="pr-0" style="text-align: right!important;"><span><pos-neg :val="i.CumulativeTotalReturn1Year" :suffix="'%'"/></span></td>
                                            <td v-if="selector!='CumulativeTotalReturn1Year'" class="pl-0" style="text-align:left!important;"><span class="sep"></span><span v-html='findRank("CumulativeTotalReturn1Year", i.ISIN)'></span></td>
                                            <td v-if="selector!='TotalReturn3Years'" class="pr-0" style="text-align: right!important;"><span><pos-neg :val="i.TotalReturn3Years" :suffix="'%'"/></span></td>
                                            <td v-if="selector!='TotalReturn3Years'" class="pl-0" style="text-align:left!important;"><span class="sep"></span><span v-html='findRank("TotalReturn3Years", i.ISIN)'></span></td>
                                            <td v-if="selector!='TotalReturn5Years'" class="pr-0" style="text-align: right!important;"><span><pos-neg :val="i.TotalReturn5Years" :suffix="'%'"/></span></td>
                                            <td v-if="selector!='TotalReturn5Years'" class="pl-0" style="text-align:left!important;"><span class="sep"></span><span v-html='findRank("TotalReturn5Years", i.ISIN)'></span></td>
                                            <td v-if="selector!='standarddev36m'" class="pr-0" style="text-align: right!important;"><span><pos-neg :val="i.standarddev36m " :suffix="'%'"/></span></td>
                                            <td v-if="selector!='standarddev36m'" class="pl-0" style="text-align:left!important;"><span class="sep"></span><span v-html='findRank("standarddev36m", i.ISIN)'></span></td>
                                            <td>
                                                <Buttons :ISIN="i.ISIN" fund-id="i.fund_id" :fund_data="i"></Buttons>
                                            </td>
                                        </tr>
                                    </template>
                                    </tbody>
                                </table>

                                <table v-if="type==3" id="comparison-table-3" class="comparison-table-3">

                                    <thead>
                                    <tr>
                                        <td>Rank</td>
                                        <td>Top {{ dict[selector].name }}</td>
                                        <td class="is-white-space-nowrap">CCY<button v-tooltip="{content: 'Currency of Share Class', trigger: 'hover click'}">?</button></td>
                                        <td class="is-white-space-nowrap pr-0" style="text-align:right!important;">OGC<button v-tooltip="{content: 'Ongoing Charge (includes Mgt Fee)', trigger: 'hover click'}">?</button></td>
                                        <td class="pl-0" style="text-align:left!important;"><span class="sep"></span>Rank</td>
                                        <td>Mgt Fee<button v-tooltip="{content: 'Management Fee', trigger: 'hover click'}">?</button></td>
                                        <td class="is-white-space-nowrap">Yield<button v-tooltip="{content: '12m Yield', trigger: 'hover click'}">?</button></td>
                                        <td>Unit<button v-tooltip="{content: 'Type of Unit available, Income, Accumulation or Both', trigger: 'hover click'}">?</button></td>
                                        <td>Distribution<button v-tooltip="{content: 'Distribution frequencies available', trigger: 'hover click'}">?</button></td>
                                        <td></td>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <template>
                                        <tr>
                                            <td colspan="10" class="full-column">
                                                <span class="has-text-weight-bold">
                                                    <router-link class="has-text-underline" :to="{name:'Detailedview Comparison',params:{id:d2.focus.ISIN}}">
                                                        {{ getShort(d2.focus.FundBasicsName) }} 
                                                    </router-link>
                                                    <button v-tooltip="{content: 'Click to see fund details', trigger: 'hover click'}">?</button>
                                                </span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td><span class="has-text-weight-bold">{{ d2.focus.rank_number }}</span></td>
                                            <td>
                                            <span class="has-text-weight-bold">
                                                <pos-neg :val="d2.focus[selector]" :suffix="'%'"/>
                                            </span>
                                            </td>
                                            <td><span>{{ d2.focus.CurrencyId }}</span></td>
                                            <td class="pr-0" style="text-align:right!important;"><pos-neg :val="d2.focus.ongoingchargecomp" :suffix="'%'"/></td>
                                            <td class="pl-0" style="text-align:left!important;"><span class="sep"></span><span v-html="findRank('ongoingchargecomp', d2.focus.ISIN)"></span></td>
                                            <td><pos-neg :val="d2.focus.ManagementFeeValue" :suffix="'%'"/></td>
                                            <td><pos-neg :val="d2.focus.yield12m" :suffix="'%'"/></td>
                                            <td v-html="accinc(d2.focus, {})">
                                            </td>
                                            <td>
                                            <span v-for="(f, i) in JSON.parse(d2.focus.distributionfrequency_all)" :key="i">
                                                <span v-if="i!==0">; </span><span v-html="getFreq(f)"></span>
                                            </span>
                                                <span style="color: #aaaaaa" v-if="d2.focus.distributionfrequency_all=='[]'">n/a</span>
                                            </td>
                                            <td>
                                                <Buttons :ISIN="d2.focus.ISIN" :fundId="d2.focus.fund_id" :fund_data="d2.focus"/>
                                            </td>
                                        </tr>
                                    </template>
                                    <template v-for="(i, index) in d2.top15">
                                        <tr :id="`row-detail-${i.ISIN}`" :key="index" v-if="counter > index">
                                            <td colspan="10" class="full-column">
                                                <span class="has-text-weight-bold">
                                                    <router-link class="has-text-underline" :to="{name:'Detailedview Comparison',params:{id:i.ISIN}}">
                                                        {{ getShort(i.FundBasicsName) }} 
                                                    </router-link>
                                                    <button v-tooltip="{content: 'Click to see fund details', trigger: 'hover click'}">?</button>
                                                </span>
                                            </td>
                                        </tr>
                                        <tr :key="index" v-if="counter > index">
                                            <td><span class="has-text-weight-bold">{{ i.rank_number }}</span></td>
                                            <td>
                                            <span class="has-text-weight-bold">
                                            <pos-neg :val="i[selector]" :suffix="'%'"/>
                                            </span>
                                            </td>
                                            <td><span>{{ i.CurrencyId }}</span></td>
                                            <td class="pr-0" style="text-align:right!important;"><pos-neg :val="i.ongoingchargecomp" :suffix="'%'"/></td>
                                            <td class="pl-0" style="text-align:left!important;"><span class="sep"></span><span v-html="findRank('ongoingchargecomp', i.ISIN)"></span></td>
                                            <td><pos-neg :val="i.ManagementFeeValue" :suffix="'%'"/></td>
                                            <td><pos-neg :val="i.yield12m" :suffix="'%'"/></td>
                                            <td v-html="accinc(d2.focus, {})">
                                            </td>
                                        <td>
                                            <span v-for="(f, i) in JSON.parse(i.distributionfrequency_all)" :key="i">
                                                <span v-if="i!==0">; </span><span v-html="(getFreq(f))"></span>
                                            </span>
                                            <span style="color: #aaaaaa" v-if="i.distributionfrequency_all=='[]'">n/a</span>
                                        </td>
                                            <td>
                                                <Buttons :ISIN="i.ISIN" :fundId="i.fund_id" :fund_data="i"/>
                                            </td>
                                        </tr>
                                    </template>
                                    </tbody>

                                </table>


                                <table v-if="type==4" id="comparison-table-3" class="comparison-table-3">
                                    <thead>
                                    <tr>
                                        <td>Rank</td>
                                        <td>Top {{ dict[selector].name }}</td>
                                        <td class="is-white-space-nowrap">CCY<button v-tooltip="{content: 'Currency of Share Class', trigger: 'hover click'}">?</button></td>
                                        <td>Style<button v-tooltip="{content: 'Managemente Style', trigger: 'hover click'}">?</button></td>
                                        <td>Open | Closed<button v-tooltip="{content: 'Open or Closed Ended Fund', trigger: 'hover click'}">?</button></td>
                                        <td class="is-white-space-nowrap">Net Assets<button v-tooltip="{content: 'Fund Net assets', trigger: 'hover click'}">?</button></td>
                                        <td class="is-white-space-nowrap">Yield<button v-tooltip="{content: '12m Yield', trigger: 'hover click'}">?</button></td>
                                        <td>Star Rating<button v-tooltip="{content: 'Morningstar Rating', trigger: 'hover click'}">?</button></td>
                                        <td>Risk Rating<button v-tooltip="{content: 'Morningstar Risk Rating. From 1-5... 1=lower risk, 5=higher risk', trigger: 'hover click'}">?</button></td>
                                        <td></td>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <template>
                                        <tr>
                                            <td colspan="10" class="full-column">
                                                <span class="has-text-weight-bold">
                                                    <router-link class="has-text-underline" :to="{name:'Detailedview Comparison',params:{id:d2.focus.ISIN}}">
                                                        {{ getShort(d2.focus.FundBasicsName) }} 
                                                    </router-link>
                                                    <button v-tooltip="{content: 'Click to see fund details', trigger: 'hover click'}">?</button>
                                                </span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td><span class="has-text-weight-bold">{{ d2.focus.rank_number }}</span></td>
                                            <td>
                                                <span class="has-text-weight-bold">
                                                    <pos-neg :val="d2.focus[selector]" :suffix="'%'"/>
                                                </span>
                                            </td>
                                            <td><span>{{ d2.focus.CurrencyId }}</span></td>
                                            <td><span v-if="d2.focus.IndexFund" class="label px-2" style="background-color: #afef97; color: #363636;">Passive</span>
                                                <span class="label active px-2" v-else
                                                >Active</span></td>
                                            <td><span v-if="d2.focus.LegalStructureId=='05'">Closed</span>
                                                <span v-else>Open</span></td>
                                            <td class="is-lowercase"><net-asset :val="d2.focus.fundnetassetgbp" /></td>
                                            <td><span><pos-neg :val="d2.focus.yield12m" :suffix="'%'"/> </span></td>
                                            <td>

                                                <span v-if="parseInt(d2.focus.starrating36M)>0">
                                                    <span class="is-white-space-nowrap" v-if="d2.focus.starrating36M && !isNaN(d2.focus.starrating36M)">
                                                        <span v-for="(r, i) in parseInt(d2.focus.starrating36M)" :key="i">
                                                            <img class="star" src="/img/star-2.svg"/>
                                                        </span>
                                                    </span>
                                                </span >
                                                <span v-else style="color: #aaaaaa">n/a</span>
                                            </td>
                                            <td>
                                                <span v-html="isNa(d2.focus.riskrating_6M)"></span>
                                            </td>

                                            <td>
                                                <Buttons :ISIN="d2.focus.ISIN" :fundId="d2.focus.fund_id" :fund_data="d2.focus"/>
                                            </td>
                                        </tr>
                                    </template>
                                    <template v-for="(i, index) in d2.top15">
                                        <tr :id="`row-detail-${i.ISIN}`" :key="index" v-if="counter>index">
                                            <td colspan="10" class="full-column">
                                                <span class="has-text-weight-bold">
                                                    <router-link class="has-text-underline" :to="{name:'Detailedview Comparison',w:{id:i.ISIN}}">
                                                        {{ getShort(i.FundBasicsName) }} 
                                                    </router-link>
                                                    <button v-tooltip="{content: 'Click to see fund details', trigger: 'hover click'}">?</button>
                                                </span>

                                            </td>
                                        </tr>
                                        <tr :key="index" v-if="counter>index">
                                            <td><span class="has-text-weight-bold">{{ i.rank_number }}</span></td>
                                            <td>
                                            <span class="has-text-weight-bold">
                                                <pos-neg :val="i[selector]" :suffix="'%'"/>
                                            </span>
                                            </td>
                                            <td><span>{{ i.CurrencyId }}</span></td>
                                            <td><span v-if="i.IndexFund" class="label px-2" style="background-color: #afef97; color: #363636;">Passive</span>
                                                <span class="label active px-2" v-else
                                                >Active</span></td>
                                            <td>
                                                <span v-if="i.LegalStructureId=='05'">Closed</span>
                                                <span v-else>Open</span>
                                            </td>
                                            <td class="is-lowercase"> <net-asset :val="i.fundnetassetgbp"/></td>
                                            <td><pos-neg :val="i.yield12m" :suffix="'%'"/></td>

                                            <td>
                                                <span v-if="parseInt(i.starrating36M)>0">
                                                    <span class="is-white-space-nowrap" v-if="i.starrating36M && !isNaN(i.starrating36M)">
                                                        <span v-for="(r, i) in parseInt(i.starrating36M)" :key="i">
                                                            <img class="star" src="/img/star-2.svg"/>
                                                        </span>
                                                    </span>
                                                </span >
                                                <span v-else style="color: #aaaaaa">n/a</span>



                                            </td>

                                            <td>
                                                <span v-html="isNa(i.riskrating_6M)"></span>
                                            </td>
                                            <td>
                                                <Buttons :ISIN="i.ISIN" :fundId="i.fund_id" :fund_data="i"/>
                                            </td>

                                        </tr>
                                    </template>
                                    </tbody>
                                </table>
                            </div>
                       </div>
                    </div>
                    <div v-if="isBannerMobile" class="column is-12-mobile is-3-tablet is-hidden-tablet">
                        <div class="banner-on-top" ref="subRight">
                            <AdsGoogle />
                        </div>
                    </div>

                    <div class="columns is-mobile">
                        <div class="column is-12-tablet disclaimer">
                            <Disclaimer />
                        </div>
                    </div>
                </div>
                <div v-if="!isBannerMobile" ref="subRight_before" class="column is-12-mobile is-3-tablet is-hidden-mobile">
                    <div class="banner-on-top" ref="subRight">
                        <AdsGoogle />
                    </div>
                </div>

            </div>
            
        </div>
        
    </div>

    <div class="preloader-center" v-else>
        <Preloader />
    </div>


</template>

<style scoped>
    .stick1{
        position: sticky;
        top:200px;
        background: #F5F4F4;
        z-index: 10
    }

    @media (min-width: 769px) {
        .graph-wrapper {
            max-height: 300px;
        }
    }
    
</style>

<script>

import commonMixin from "@/mixins/commonMixin";
import compositeMixin from "@/mixins/compositeMixin";
import bannerMixin from "@/mixins/bannerMixin";
import Preloader from "@/components/Preloader"
import axios from "axios";
import Buttons from "@/components/Buttons";
import PosNeg from "@/components/PosNeg";
import NetAsset from "@/components/NetAsset";
import BackButton from "@/components/BackButton";
import BarChart from "@/components/BarChart";
import CurrencyToggle from "@/components/CurrencyToggle";
import { mapState } from 'vuex'
import PageHelpDropdown from '@/components/PageHelpDropdown.vue';
import Disclaimer from "@/components/Disclaimer"
import AdsGoogle from '@/components/AdsGoogle.vue';

export default {
    name: 'Campare',
    components: {CurrencyToggle, BarChart, BackButton, NetAsset, PosNeg, Buttons, PageHelpDropdown, Preloader, Disclaimer, AdsGoogle},
    props: {},
    mixins: [commonMixin, compositeMixin, bannerMixin],
    data() {
        return {
            title: ' | Compare To Peers | Pickafund',
            currencyNative:true,
            dict: {
                "CumulativeTotalReturn1Year": {
                    id: "CumulativeTotalReturn1Year",
                    name: "NTR 1Y",
                },
                "TotalReturn3Years": {
                    id: "TotalReturn3Years",
                    name: "NTR 3Y",
                },
                "TotalReturn5Years": {
                    id: "TotalReturn5Years",
                    name: "NTR 5Y",
                },
                "ongoingchargecomp": {
                    id: "ongoingchargecomp",
                    name: "OGC",
                },
                "standarddev36m": {
                    id: "standarddev36m",
                    name: "3Y SD",
                }
            },
            isLoading: true,
            type: 1,
            d: [],
            d2: {},
            selector: "CumulativeTotalReturn1Year",
            counter: 10,
            ranks: null,
        }
    },
    methods: {
        windowScroll() {
            if (Object.keys(this.d2).length > 0) {
                this.handleScroll()
            }
            
        },
        currencyChange(){
            this.setUp(null)
            this.api()
        },
        getVals(obj) {
            return obj
        },
        api() {
            axios.get('/search/getcomparison/' + this.$route.params.id,
                {params: {
                    type: this.selector,
                    native: this.$store.state.search.currency,
                    savecomp: 'save',
                    source: 'comparison_page',
                }}
            )
                .then((response) => {
                    this.d2 = response.data
                    this.getRanks()

                })
                .catch((error) => {
                    alert(error)
                })
        },
        findRank(type, fundid){
            
            if(this.ranks){
                const i = this.ranks[type].find(item => {
                   return item.mainid == fundid
                })
                if(i && i.rank){ 
                    return i.rank                  
                } else {
                    return "<span style='color:#AAAAAA'>n/a</span>"
                }
            }
            
        },
        isNa(x){
           if(x===null){
               return "<span style='color:#AAAAAA'>n/a</span>"
           }
           else if(x===''){
               return "<span style='color:#AAAAAA'>n/a</span>"
           }
           return x
        },
        getRanks() {
            let ids = []
            this.d2.top15.forEach(item => ids.push(item.ISIN))
            ids.push(this.d.focus.ISIN)
            axios.get('/search/toprank/',
                {
                    params:
                        {
                            ISIN: ids,
                            category: this.d.focus.CategoryId,
                            native: this.$store.state.search.currency,
                        }
                }
            )
                .then((response) => {
                    this.ranks = response.data
                })
                .catch((error) => {
                    alert(error)
                })
        },
        async setUp(isSave){
            await axios.get('/search/getcomparison/' + this.$route.params.id, {params: {
                    native: this.$store.state.search.currency,
                    type: this.selector,
                    savecomp: isSave && !this.$store.state.compare.isBackBtn ? isSave : undefined,
                    source: !this.$store.state.compare.isBackBtn ? this.$store.state.compare.typeCompareDetail : undefined
                }})
                .then((response) => {
                    this.d = response.data
                    this.title = this.d.focus.FundBasicsName + ' | Compare To Peers | Pickafund',
                    this.d2 = response.data
                    this.isLoading = false
                    this.$bus.$emit("loadingPage", false)
                    this.getRanks()
                })
                .catch((error) => {
                    alert(error)
                })
            if(this.$store.state.compare.isBackBtn) {
                this.$store.commit('compare/SET_TYPE_BACK_BTN', false)
            }
        },
        getCurrentPositionOfTableCompareInformation (nameRoute) {
            let tableCompareInformationElement = document.getElementById('table-information-compare')
            if(tableCompareInformationElement && tableCompareInformationElement.offsetTop && (nameRoute === 'Referral' || nameRoute === 'Detailedview Comparison')) {
                this.$store.commit('compare/SET_POSTION_TABLE_COMPARE', tableCompareInformationElement.offsetTop)
            } else {
                this.$store.commit('compare/SET_POSTION_TABLE_COMPARE', 0)
            }
        },
        getCurrentRowAndInformationOfTableCompare (id) {
            let rows = document.getElementById('comparison-table-3').rows
            rows = Array.prototype.slice.call(rows)
            if (id) {
                let indexRowOfTable = rows.findIndex(el => {
                    return el.id === `row-detail-${id}`
                })
                this.$store.commit('compare/SET_DATA_CURRENT_ROW_TABLE', {
                    indexRow: indexRowOfTable,
                    type: this.type,
                    counter: this.counter
                })
            }
        },
        async searchISIN(isin){
            if (!isin) return
            await this.resetSearchResults();
            await this.$store.dispatch("search/apiCall",{
                type: "isin",
                text: isin,
                code: isin,
                source: 1,
            })
            this.$store.commit("search/SET_NEW_SEARCH_SECTION", true)
            window.scrollTo(0,0);
            await this.$router.push({name:"Results", params: {id: this.$store.state.search.searchData.searchdata_id, text: isin}})
        },
        async searchCategory(typeFund, typeCategory) {
            await this.resetSearchResults();
            await this.$store.dispatch("search/apiCall", {
                "fund": typeCategory,
                "type": "category",
                "text": typeCategory,
                "code": [typeFund],
                "source": 5,
            })
            this.$store.commit("search/SET_ABSOLUTETOTAL", this.$store.state.search.searchData.total)
            this.$store.commit("search/SET_NEW_SEARCH_SECTION", true)

            const textURL = this.convertURL(typeCategory.replaceAll('/', '*'))
            window.scrollTo(0,0);
            await this.$router.push({name:"Results", params: {id: this.$store.state.search.searchData.searchdata_id, text: textURL}})
        },
        resetSearchResults() {
            this.$store.commit("search/SET_CURRENT_PAGE",1)
            this.$store.commit("search/SET_FILTERS",{})
            this.$store.commit("search/SET_PROV_FILTERS",{})
            this.$store.commit("search/SET_PROVISIONAL_RES",{})
            this.$store.commit("search/SET_COUNT_BASIC", 0);
            this.$store.commit("search/SET_COUNT_ADVANCE", 0);
            this.$store.commit("search/SET_SORTDIR1","DESC")
            this.$store.commit("search/SET_SORTDIR2","DESC")
            this.$store.commit("search/SET_SORTING1","CumulativeTotalReturn1Year")
            this.$store.commit("search/SET_SORTING2",null)
            this.$store.commit("search/SET_SHOW_SECOND_OPTION", false);
        }
    },
    updated () {
        if (this.postitionTableCompare) {
            window.scrollTo(0, this.postitionTableCompare - 200)
            this.$store.commit('compare/SET_POSTION_TABLE_COMPARE', 0)
            // check and go to row table choosed to go to next page
            let rows = document.getElementById('comparison-table-3').rows
            rows[this.dataOfCurrentRowInTableCompare.indexRow].scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            })
        }
    },
    watch:{
        currencyNative(n){
            if(n===true){
                this.$store.commit("search/SET_CURRENCY","native")
            }
            else{
                this.$store.commit("search/SET_CURRENCY","base")
            }
            this.setUp()
            this.api()
        },
        selector(n){
          this.$store.commit("compare/SET_CAT",n)
        },
        '$route': function () {
            this.setUp('save')
            this.type=1;
        }
    },
    async mounted() {
        this.selector = this.$store.state.compare.cat
        await this.setUp('save')
        this.type = this.dataOfCurrentRowInTableCompare.type
        this.counter = 10

        this.$store.commit('compare/SET_TYPE_COMPARE_DETAIL', 'comparison_page');
    },

    beforeRouteLeave (to, from, next) {
        this.getCurrentPositionOfTableCompareInformation(to.name)      
        this.getCurrentRowAndInformationOfTableCompare(to.params.id)
        if(to.name == from.name){
            this.selector = this.$store.state.compare.cat
            //this.setUp()
        }
        next()
    },

    computed: {
        ...mapState('compare', {
            postitionTableCompare: 'postitionTableCompare',
            dataOfCurrentRowInTableCompare: 'dataOfCurrentRowInTableCompare'
        }),
    },

    metaInfo() {
        return {
            title: `${this.d.focus ? this.d.focus.FundBasicsName + ' - ' : ''}Comparison To Peers | Pickafund`,
            meta: [
                { name: 'description', content:  'Use our 5 criteria to compare your investment fund to its category peers in a clear and transparent way'},
                { vmid: 'og:description', property: 'og:description', name: 'description', content:  "Use our 5 criteria to compare your Fund to its category peers in a clear and transparent way"},
                { vmid: 'og:title', property: 'og:title', content: `${this.d.focus ? this.d.focus.FundBasicsName : ''} - Comparison To Peers | Pickafund`},
            ],
            content: 'Pickafund comparing your chosen Funds for valuable insight. Check out this Fund!'
        }
    },
    created() {
        window.addEventListener('scroll', this.windowScroll);
        this.$bus.$emit("loadingPage", true)
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.windowScroll);
    },
}

</script>


